export const techniqueFields = [
  ['GVI', 'in_gvi'],
  ['RVI', 'in_rvi'],
  ['CVI', 'in_cvi'],
  ['FVI', 'in_fvi']
]

export function textValue (value) {
  return value === null || value === undefined ? '' : String(value).trim()
}

// Never use Boolean(value): Boolean('0') and Boolean('false') are true.
export function readFlag (value) {
  if (value === true || value === 1) return true
  if (value === false || value === 0) return false
  const text = textValue(value).toLowerCase()
  if (['true', '1', 'yes', 'y'].includes(text)) return true
  if (['false', '0', 'no', 'n'].includes(text)) return false
  return null
}

export function flagLabel (value) {
  const flag = readFlag(value)
  return flag === null ? 'Unknown' : flag ? 'Yes' : 'No'
}

export function eligibleTechniques (row) {
  return techniqueFields
    .filter(([, field]) => readFlag(row[field]) === true)
    .map(([technique]) => technique)
}

export function techniqueLabel (row) {
  const enabled = eligibleTechniques(row)
  const unknown = techniqueFields.some(
    ([, field]) => readFlag(row[field]) === null
  )
  if (!enabled.length)
    return unknown ? 'Eligibility not fully recorded' : 'None eligible'
  return enabled.join(' · ') + (unknown ? ' · Other flags unknown' : '')
}

export function componentKey (row) {
  return JSON.stringify([
    textValue(row.site_id),
    textValue(row.asset_id),
    textValue(row.id),
    textValue(row.rds_code)
  ])
}

export function hasComponentLocation (row) {
  return Boolean(textValue(row.site_id) && textValue(row.asset_id))
}

export function inScope (row, siteId, assetId) {
  return (
    (!siteId || textValue(row.site_id) === textValue(siteId)) &&
    (!assetId || textValue(row.asset_id) === textValue(assetId))
  )
}

export const componentFilters = [
  {
    key: 'subsystem',
    label: 'Subsystem',
    values: row => [textValue(row.subsystem) || 'Unknown']
  },
  { key: 'technique', label: 'Eligible technique', values: eligibleTechniques }
]

export function componentSearchText (row) {
  return [
    row.rds_code,
    row.description,
    row.subsystem,
    row.site_id,
    row.asset_id,
    row.siteLabel,
    row.assetLabel,
    ...eligibleTechniques(row)
  ]
    .map(textValue)
    .join(' ')
}

export function sameComponentCode (row, component) {
  return (
    Boolean(textValue(component.rds_code)) &&
    textValue(row.site_id) === textValue(component.site_id) &&
    textValue(row.asset_id) === textValue(component.asset_id) &&
    textValue(row.rds_code).toLowerCase() ===
      textValue(component.rds_code).toLowerCase()
  )
}

export function relatedAnomalies (rows, component) {
  if (!hasComponentLocation(component) || !textValue(component.rds_code))
    return []
  return rows.filter(row =>
    sameComponentCode({ ...row, rds_code: row.rds_component }, component)
  )
}

export function sortComponents (rows, sort, columns) {
  const column = columns.find(item => item.key === sort.key)
  if (!column) return rows
  const direction = sort.direction === 'desc' ? -1 : 1
  return [...rows].sort(
    (a, b) =>
      direction *
      textValue(column.value(a)).localeCompare(
        textValue(column.value(b)),
        undefined,
        { numeric: true, sensitivity: 'base' }
      )
  )
}

// Give every row the same union of raw keys. Preserve fields absent from row 1.
export function componentExportRows (rows, columns) {
  const keys = [
    ...new Set([
      ...columns.map(column => column.key),
      ...rows.flatMap(row => Object.keys(row.raw))
    ])
  ]
  return rows.map(row =>
    Object.fromEntries(keys.map(key => [key, row.raw[key] ?? '']))
  )
}
